import { ref, computed } from '@vue/composition-api';

export const browseDatasetMenu = ref(false);
export const generateDatasetMenu = ref(false);

// Upload Video Dialog
export const uploadVideoFileMenu = ref(false);
export const files = ref<File[]>([]);
export const uploadDialogWidth = computed(() => (files.value.length >= 3 ? 'unset' : '35vw'));

// Manage Video Dialog
export const manageVideoFilesMenu = ref(false);
